import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QualificationV2CategoryNamePipe } from '@wilson/qualification-v2/common';
import { AgRendererComponent } from 'ag-grid-angular';
import { OnClickRendererParams } from './confirmed-by-user-renderer';

@Component({
  selector: 'wilson-qualification-category-renderer',
  template: `
    <div class="cursor-pointer" (click)="onClick($event)">
      <div class="text-dark">
        {{ categoryId | qualificationV2CategoryName | async }}
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, QualificationV2CategoryNamePipe],
})
export class QualificationCategoryRendererComponent
  implements AgRendererComponent
{
  public categoryId!: string;
  params!: OnClickRendererParams;

  agInit(params: OnClickRendererParams): void {
    this.params = params;
    this.categoryId = this.getValueToDisplay(params);
  }

  refresh(params: OnClickRendererParams): boolean {
    this.categoryId = this.getValueToDisplay(params);
    this.params = params;
    return true;
  }

  getValueToDisplay(params: OnClickRendererParams): string {
    return params.data?.qualification.qualificationCategoryId;
  }

  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.params?.onClick) {
      this.params.onClick(event, this.params.data);
    }
  }
}
